import classNames from "classnames";

import { useState } from "react";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../hooks/reduxHooks";
import { resetObjectToInitialState } from "../../../../../store/slices/viewSlice";

const parsedColors = ["#022A44", "#F1E5CA", "#820219", "#818889"];

const availableColors = [
  "#dedede",
  "#939495",
  "#747163",
  "#f6e44a",
  "#f4a323",
  "#fff98a",
  "#20419a",
  "#0ca2bd",
  "#353f4b",
  "#ff7700",
  "#3f510d",
  "#02642e",
  "#c3f17a",
  "#6fcf91",
  "#b1ecb5",
  "#b51717",
  "#ef4848",
  "#ffc2c4",
  "#5e3a8c",
  "#55387a",
  "#34101b",
];

const ChangeColors = ({ handleChangeColors }: any) => {
  const [currentColor, setCurrentColor] = useState(parsedColors[0]);
  const dispatch = useAppDispatch();
  const win: any = window;
  const selectedViewId = useAppSelector(
    (state: any) => state.canvases.selectedViewId
  );
  const canvas: any = win["design_canvas"][selectedViewId];
  const handleReset = () => {
    dispatch(resetObjectToInitialState({}));

    canvas.renderAll();
  };
  return (
    <>
      <div className="flex items-center gap-3 font-bold text-2xl tracking-wide border-b border-solid border-lightgrey pb-2">
        <span onClick={handleChangeColors} className="cursor-pointer">
          <svg
            width="19"
            height="14"
            viewBox="0 0 19 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.4989 5.83273H3.98294L7.82449 1.99118C7.9328 1.88287 8.01872 1.75428 8.07734 1.61277C8.13595 1.47125 8.16612 1.31958 8.16612 1.1664C8.16612 1.01323 8.13595 0.861555 8.07734 0.720041C8.01872 0.578526 7.9328 0.449943 7.82449 0.341632C7.71618 0.233321 7.5876 0.147405 7.44608 0.0887872C7.30457 0.0301699 7.15289 -1.14124e-09 6.99972 0C6.84654 1.14124e-09 6.69487 0.0301699 6.55336 0.0887872C6.41184 0.147405 6.28326 0.233321 6.17495 0.341632L0.342043 6.17454C0.233614 6.28278 0.147593 6.41134 0.0889014 6.55287C0.0302099 6.69439 0 6.8461 0 6.99931C0 7.15252 0.0302099 7.30423 0.0889014 7.44575C0.147593 7.58727 0.233614 7.71584 0.342043 7.82408L6.17495 13.657C6.28303 13.7657 6.41154 13.852 6.55309 13.9108C6.69463 13.9697 6.84642 14 6.99972 14C7.15302 14 7.3048 13.9697 7.44635 13.9108C7.58789 13.852 7.7164 13.7657 7.82449 13.657C7.93292 13.5487 8.01894 13.4202 8.07763 13.2787C8.13632 13.1371 8.16653 12.9854 8.16653 12.8322C8.16653 12.679 8.13632 12.5273 8.07763 12.3858C8.01894 12.2442 7.93292 12.1157 7.82449 12.0074L3.98294 8.16589H17.4989C17.8083 8.16589 18.1051 8.04298 18.3238 7.8242C18.5426 7.60543 18.6655 7.3087 18.6655 6.99931C18.6655 6.68991 18.5426 6.39319 18.3238 6.17441C18.1051 5.95563 17.8083 5.83273 17.4989 5.83273Z"
              fill="#424447"
            />
          </svg>
        </span>{" "}
        Change Colors
      </div>
      <div className="py-4">
        <div className="flex justify-between items-center">
          <span className="font-bold">Choose a Color to Change</span>
          <button
            className="text-primaryred text-sm cursor-pointer"
            onClick={handleReset}
          >
            Reset to Original
          </button>
        </div>
        <div className="flex gap-2 pt-3">
          {parsedColors.map((color, index) => (
            <div
              key={index}
              className={classNames(
                "w-[24px] h-[24px] rounded-full border border-solid border-lightgrey cursor-pointer",
                {
                  ["border-2 border-primaryred"]: color === currentColor,
                }
              )}
              style={{ backgroundColor: color }}
              onClick={() => setCurrentColor(color)}
            ></div>
          ))}
        </div>
      </div>
      <div className="border-t border-solid border-lightgrey py-4">
        <div className="flex items-center gap-1">
          <span className="font-bold">Color:</span>
          <div
            className="w-[24px] h-[24px] rounded-full border border-solid border-lightgrey"
            style={{ backgroundColor: currentColor }}
          ></div>{" "}
          <span className="text-sm">Original</span>
        </div>
        <div className="flex flex-wrap gap-2 my-3">
          {availableColors.map((color, index) => (
            <div
              key={index}
              className="w-[24px] h-[24px] rounded-full border border-solid border-lightgrey cursor-pointer"
              style={{ backgroundColor: color }}
            ></div>
          ))}
        </div>
        <button className="bg-primaryred rounded-md font-bold text-white w-full py-2 my-2">
          Save Changes
        </button>
      </div>
    </>
  );
};

export default ChangeColors;
